import React, { useState } from "react";
import { TopicSelector } from "./TopicSelector";
import { DifficultySelector } from "./DifficultySelector";
import { useNavigate } from "react-router-dom"; // Ensure proper import
import "./ScheduleTest.css";

export function ScheduleTest({ onClose, testType }) {
  const navigate = useNavigate();
  const [difficulty, setDifficulty] = useState("");
  const [topic, setTopic] = useState("AI/ML");

  const handleButtonClick = async () => {
    if (!difficulty || !topic) {
      alert("Please select both a topic and difficulty level.");
      return;
    }

    const formData = new URLSearchParams();
    formData.append("level", difficulty);
    formData.append("topic", topic);

    try {
      if (testType === "coding") {
        const response = await fetch("/api/code", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: formData.toString(),
        });
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Server error: ${errorText}`);
        }

        const data = await response.json();
        console.log("Received Data:", data);

        // Redirect to practice page with generated question
        navigate('/practice', { state: { question: data.question } });
        // navigate(`/icoding`, { state: { questions, resumeQuestions, testType } });
        console.log("Navigated to practice page", data.question);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while generating the question.");
    }
  };

  return (
    <div className="schedule-container">
      <div className="schedule-content">
        <div className="schedule-form">
          <TopicSelector onChange={setTopic} />
          <DifficultySelector onChange={setDifficulty} />
        </div>
        <button className="schedule-button" onClick={handleButtonClick} style={{
          maxWidth: "500px",
          width: "100%",
          margin: "0 auto",
        }}>
          <img
            className="schedule-icon"
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/c6d50539e7c372e93521beafef79bc2996f1ededfb10f646205686c27bfd0bc2"
            alt="Schedule Test"
          />
          <span className="get-link">Generate Questions</span>
        </button>
      </div>
      <img
        className="close-icon"
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/1cd64b1d85b0d8bb3fb63afaa1db98c83fe72cd802b9613ffc742636d4291cad"
        alt="Close"
        onClick={onClose}
      />
    </div>
  );
}